export const storeAllStaff = (state, action) => {
  state.staffList = action.payload.AllEntityMember;
};
